import PropTypes from 'prop-types';

export const userMcpConnectionShape = PropTypes.shape({
    provider: PropTypes.string.isRequired,
    display_name: PropTypes.string.isRequired,
    available: PropTypes.bool.isRequired,
    connected: PropTypes.bool.isRequired,
    expired: PropTypes.bool.isRequired,
});
